import { render, staticRenderFns } from "./LibraryBlurb.vue?vue&type=template&id=2a291899&scoped=true"
import script from "./LibraryBlurb.vue?vue&type=script&lang=js"
export * from "./LibraryBlurb.vue?vue&type=script&lang=js"
import style0 from "./LibraryBlurb.vue?vue&type=style&index=0&id=2a291899&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a291899",
  null
  
)

export default component.exports